import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ 
    rating = 0, 
    size = 16, 
    showNumber = false, 
    showCount = false, 
    reviewCount = 0,
    className = "",
    interactive = false,
    onRatingChange = null,
    hoverRating = 0,
    onHover = null,
    onMouseLeave = null
}) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    const handleStarClick = (starRating) => {
        if (interactive && onRatingChange) {
            onRatingChange(starRating);
        }
    };

    const handleStarHover = (starRating) => {
        if (interactive && onHover) {
            onHover(starRating);
        }
    };

    const displayRating = hoverRating || rating;

    return (
        <div className={`flex items-center space-x-1 ${className}`}>
            <div className="flex items-center star-rating">
                {[1, 2, 3, 4, 5].map((star) => {
                    const isActive = star <= displayRating;
                    const isHalf = star === Math.ceil(displayRating) && displayRating % 1 >= 0.5 && !isActive;
                    
                    return (
                        <button
                            key={star}
                            type="button"
                            onClick={() => handleStarClick(star)}
                            onMouseEnter={() => handleStarHover(star)}
                            onMouseLeave={onMouseLeave}
                            className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} p-0.5`}
                            disabled={!interactive}
                        >
                            <Star
                                size={size}
                                className={`${
                                    isActive 
                                        ? 'text-yellow-400 fill-current' 
                                        : isHalf 
                                        ? 'text-yellow-400 fill-current opacity-50' 
                                        : 'text-gray-300'
                                } transition-colors duration-200`}
                            />
                        </button>
                    );
                })}
            </div>
            
            {showNumber && (
                <span className="text-sm font-medium text-gray-700 ml-1 rating-number">
                    {rating > 0 ? rating.toFixed(1) : '0.0'}
                </span>
            )}
            
            {showCount && reviewCount > 0 && (
                <span className="text-sm text-gray-500 ml-1">
                    ({reviewCount} {reviewCount === 1 ? 'review' : 'reviews'})
                </span>
            )}
        </div>
    );
};

export default StarRating;
